import { CORE_DRAWER_IDS, drawersActions, useDispatchDrawers, useOpenDrawer } from "contexts/drawers";
import { usePropertiesPanelSubtitle } from "hooks/usePropertiesPanelSubtitle";

import { DrawerComponent } from "./Drawer";

/**
 * Drawer Container
 *
 * Container that renders the currently open drawer.
 * Only one drawer can be open at a time.
 */
export function DrawerContainer() {
    const openDrawer = useOpenDrawer();
    const dispatch = useDispatchDrawers();

    const propertiesSubtitle = usePropertiesPanelSubtitle();

    const handleClose = () => {
        dispatch(drawersActions.closeDrawer());
    };

    if (!openDrawer) {
        return null;
    }

    const DrawerContent = openDrawer.component;
    const subtitle = openDrawer.id === CORE_DRAWER_IDS.PROPERTIES ? propertiesSubtitle : undefined;

    return (
        <DrawerComponent
            title={openDrawer.title}
            subtitle={subtitle}
            icon={openDrawer.icon}
            isOpen={true}
            onClose={handleClose}
            hideHeader={openDrawer.hideHeader}
            data-testid={`drawer-${openDrawer.id}`}
        >
            <DrawerContent onClose={handleClose} />
        </DrawerComponent>
    );
}
